import QuoteProposalSidebar from "./QuoteProposalSidebar";
import QuoteProposalHeader from "./QuoteProposalHeader";
import { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PreviewIcon from "../assets/images/ViewDetailsIcon.png";
import GeneratedProposal from "./GeneratedProposal";
import { Toast } from "primereact/toast";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { Guid } from "js-guid";
import moment from "moment";
import html2pdf from "html2pdf.js";
import CommonValues from "../common/utils";
import AtkButton from "../AtlaskitControls/AtkButton";
import SupportLoader from "../common/SupportLoader";


export default function Dashboard() {
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [visible, setVisible] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [spinnerloading, setSpinnerLoading] = useState(false);
  const toast: any = useRef("");
  const hostname = window.location.origin;
  const navigate = useNavigate();
  const [totalProposals, setTotalProposals] = useState("");
  const [proposalsThisMonth, setProposalsThisMonth] = useState("");
  const proposalRef = useRef(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  useEffect(() => {
    getRecentProposalDetails();
    getQuoteProposalsCount();
  }, []);
  const getQuoteProposalsCount = () => {
    var token = CommonValues.GetToken();
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/nc-quote-proposal-count`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .request(config)
      .then((response: any) => {
        setTotalProposals(response.data.totalProposals);
        setProposalsThisMonth(response.data.proposalsThisMonth);
      })
      .catch((error: any) => {});
  };
  const getRecentProposalDetails = () => {
    const token = CommonValues.GetToken();
    setSpinnerLoading(true);
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/nc-quote-proposal-history`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        const rawData = response.data;
        const formattedData = rawData.slice(0, 10).map((item: any) => ({
          fileName: item.quoteApplicationPdf || "NA",
          submittedDate: item.created || "",
          status: item.status || 0,
          transactionId: item.transactionId || "",
          clientName: item.clientName,
        }));
        setHistoryData(formattedData);
        setSpinnerLoading(false);
      })
      .catch((error: any) => {
        setSpinnerLoading(false);

        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while loading the details",
              life: 3000,
            });
          }
        }
      });
  };
  const statusBodyTemplate = (rowData: any) => {
    return rowData.status === 0 ? (
      <span className="p-1 text-dark rounded d-inline-block text-center" style={{ minWidth: "80px", backgroundColor: "rgba(255, 193, 7, 0.3)" }}>
        Draft
      </span>
    ) : rowData.status === 1 ? (
      <span className="p-1 rounded text-dark d-inline-block text-center" style={{ minWidth: "80px", backgroundColor: "rgba(25, 135, 84, 0.3)" }}>
        Generated
      </span>
    ) : null;
  };

  const onDraftLinkClick = (data: any) => {
    navigate(`/newquoteproposal/${data.transactionId}`);
  };
  const previewIcon = (rowData: any) => {
    if (rowData.status === 0) {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onDraftLinkClick(rowData);
          }}
          className="text-14"
        >
          <i className="fa fa-arrow-up-right-from-square"></i>
        </a>
      );
    }

    return (
      <img
        src={PreviewIcon}
        height={20}
        onClick={() => onPreviewClicked(rowData.transactionId)}
        title="Preview"
        style={{ cursor: "pointer" }}
        alt="Preview"
      />
    );
  };
  const onPreviewClicked = (id: string) => {
    if (id) {
      setTransactionId(id);
      setVisible(true);
    }
  };
  const CopyToClipBoardClicked = () => {
    navigator.clipboard
      .writeText(`${hostname}/quoteproposal/${transactionId}`)
      .then(() => {
        toast.current.show({ severity: "success", summary: "Success", detail: "Copied!", life: 3000 });
      })
      .catch(() => {
        toast.current.show({ severity: "error", summary: "Error", detail: "Failed to copy", life: 3000 });
      });
  };
  const onNewProposalClick = () => {
    navigate(`/newquoteproposal/${Guid.newGuid()}`);
  };
  const onHideClick = () => {
    setVisible(false);
    setIsGeneratingPdf(false);
  };
  const onDownloadClicked = () => {
    setIsGeneratingPdf(true);
    if (!proposalRef.current) return;

    setTimeout(() => {
      const opt = {
        margin: 0.5,
        filename: `Proposal-${transactionId}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(opt)
        .from(proposalRef.current)
        .save()
        .then(() => {
          setIsGeneratingPdf(false);
        })
        .catch(() => {
          setIsGeneratingPdf(false);
        });
    }, 500);
  };
  return (
    <div className="position-relative">
      <Toast ref={toast} />

      <QuoteProposalSidebar pagename="proposal-dashboard" />
      <div className="flex-grow-1 d-flex flex-column overflow-hidden">
        <QuoteProposalHeader />
        <main className="flex-grow-1 overflow-auto p-4 bg-light quote-proposal-main-content">
          <div className="mb-4 d-flex flex-col justify-content-between">
            <h2 className="fs-4 fw-bold">Dashboard</h2>
            <AtkButton label="+ Create New Proposal" onClick={onNewProposalClick} className="w-auto pf-primary-btn" />
          </div>

          <div className="row g-4 ">
            <div className="col-3">
              <div className="card h-100 shadow-sm border rounded">
                <div className="d-flex align-items-center justify-content-between p-3 pb-2">
                  <h5 className="mb-0 small fw-medium">Total Proposals</h5>
                  <span className="bg-purple p-1 rounded">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-muted"
                    >
                      <line x1="12" x2="12" y1="20" y2="10"></line>
                      <line x1="18" x2="18" y1="20" y2="4"></line>
                      <line x1="6" x2="6" y1="20" y2="16"></line>
                    </svg>
                  </span>
                </div>
                <div className="px-3 pb-3 pt-0">
                  <div className="fs-4 fw-bold">{totalProposals}</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="card h-100 shadow-sm border rounded">
                <div className="d-flex align-items-center justify-content-between p-3 pb-2">
                  <h5 className="mb-0 small fw-medium">Proposals this month</h5>
                  <span className="bg-purple p-1 rounded">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-muted"
                    >
                      <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z"></path>
                      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                    </svg>
                  </span>
                </div>
                <div className="px-3 pb-3 pt-0">
                  <div className="fs-4 fw-bold">{proposalsThisMonth}</div>
                </div>
              </div>
            </div>
            <div className="col-12 ">
              <div className=" d-flex flex-column gap-1 history-table card p-2 ">
                <h5
                  className="fw-semibold"
                  style={{
                    fontWeight: 500,
                    fontSize: "1.2rem",
                    marginBottom: "1rem",
                    color: "#1f2937",
                  }}
                >
                  Recent Quote Proposals
                </h5>
                {spinnerloading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <SupportLoader />{" "}
                  </div>
                ) : (
                  <DataTable value={historyData} rows={10} emptyMessage="No data available.">
                    <Column header="Client Name" field="clientName" sortable />
                    <Column header="File Name" field="fileName" />
                    <Column
                      header="Submitted Date"
                      field="submittedDate"
                      body={(rowData) => {
                        const utcdate = moment.utc(rowData.submittedDate);
                        var localDate = moment(utcdate).local();
                        return <span className="">{localDate.format("MM/DD/YYYY HH:mm")} </span>;
                      }}
                    />
                    <Column header="Status" body={statusBodyTemplate} field="status" />

                    <Column body={previewIcon} header="Proposal Preview" />
                  </DataTable>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
      <Dialog
        header={
          <div className="d-flex justify-content-between align-items-center w-100">
            <span>Preview Your Proposal</span>
             <span>
                <i className="fa fa-copy show-cursor me-2" aria-hidden="true" title="Copy" onClick={CopyToClipBoardClicked}></i>
                <i className="fa fa-download ms-2 show-cursor" title="Download as pdf" style={{ fontSize: "16px" }} onClick={onDownloadClicked} />
              </span>
          </div>
        }
        visible={visible}
        style={{ width: "80%" }}
        onHide={onHideClick}
        modal
        draggable={false}
      >
        <div ref={proposalRef}>
          <GeneratedProposal transactionId={transactionId} isEditable={true} isGeneratingPdf={isGeneratingPdf} />
        </div>
      </Dialog>
    </div>
  );
}
